<button mat-icon-button [matMenuTriggerFor]="userMenu" #userMenuTrigger="matMenuTrigger">
  <mat-icon>account_circle</mat-icon>
</button>

<mat-menu #userMenu="matMenu" [overlapTrigger]="false" class="toolbar-dropdown-menu user-menu">
  <mat-card fxLayout="row" fxLayoutAlign="space-around center" class="user-info p-0">
    <img [src]="userImage" alt="user-image" />
    <div fxLayout="column" fxLayoutAlign="center center">
      <h2>{{ tokenData?.user_name }}</h2>
      <h3 class="secondary-text-color">{{ tokenData?.email }}</h3>
    </div>
  </mat-card>
  <mat-divider></mat-divider>
  <div>
    <a mat-menu-item has-permission [permission]="providerRole" (click)="updateProfile()">
      <mat-icon>person</mat-icon>
      <span>{{ 'MENU.PROFILE' | translate }}</span>
    </a>
  </div>

  <a mat-menu-item (click)="changePassword()">
    <!--routerLink="settings" -->
    <mat-icon>settings</mat-icon>
    <span>{{ 'MENU.CHANGE_PASSWORD' | translate }}</span>
  </a>
  <mat-divider></mat-divider>
  <a mat-menu-item (click)="logout()">
    <mat-icon>power_settings_new</mat-icon>
    <span>{{ 'GENERAL.LOGOUT' | translate }}</span>
  </a>
  <!--</span>-->
</mat-menu>
